import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  AddressEntityType,
  ModernizationLevelType,
  ModernizationMethodType,
} from 'types/ApiResponse'
import {
  StyledDataColumn,
  StyledDataContainer,
  StyledDataProperty,
  StyledHeader,
  StyledLine,
  StyledPropertyLabel,
  StyledPropertyValue,
  StyledSectionContainer,
} from '../PropertyInfo.styled'

const ModernizationInfo = (props: any) => {
  const { propertyData }: { propertyData: AddressEntityType } = props
  const { t } = useTranslation()
  const modernizationMatrix = propertyData.propertyDetails?.modernizationMatrix
  const method = propertyData?.propertyDetails?.modernizationMethod

  const getModernizationValue = (value?: ModernizationLevelType) => {
    return value ? t(`modernizationLevel.${value?.toLowerCase()}`) : '—'
  }

  return (
    <StyledSectionContainer>
      <StyledLine style={{ marginTop: 0, marginBottom: '10px' }} />
      <StyledHeader>{t('newAddressModal.modernizationTab.label')}</StyledHeader>
      <StyledDataContainer>
        <StyledDataColumn>
          <StyledDataProperty>
            <StyledPropertyLabel>
              {t('newAddressModal.modernizationTab.modernizationMethod')}
            </StyledPropertyLabel>
            <StyledPropertyValue>
              {propertyData?.propertyDetails?.modernizationMethod
                ? t(
                    `modernizationMethod.${propertyData?.propertyDetails?.modernizationMethod?.toLowerCase()}`
                  )
                : '—'}
            </StyledPropertyValue>
          </StyledDataProperty>
          {method !== ModernizationMethodType.AUTOMATIC && (
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.modernizationTab.refurbishmentYear')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {propertyData?.propertyDetails?.refurbishmentYear
                  ? propertyData?.propertyDetails?.refurbishmentYear
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
          )}
          {method === ModernizationMethodType.SIMPLE && (
            <StyledDataProperty>
              <StyledPropertyLabel>{t('addressModal.modernizationClass')}</StyledPropertyLabel>
              <StyledPropertyValue>
                {propertyData?.propertyDetails?.modernizationValue
                  ? t(
                      `modernizationValue.${propertyData?.propertyDetails?.modernizationValue?.toLowerCase()}`
                    )
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
          )}
          {method === ModernizationMethodType.COSTS && (
            <StyledDataProperty>
              <StyledPropertyLabel>
                {t('newAddressModal.modernizationTab.modernizationCost')}
              </StyledPropertyLabel>
              <StyledPropertyValue>
                {propertyData?.propertyDetails?.modernizationCost
                  ? propertyData?.propertyDetails?.modernizationCost
                  : '—'}
              </StyledPropertyValue>
            </StyledDataProperty>
          )}
        </StyledDataColumn>
        {method === ModernizationMethodType.DETAILED ? (
          <>
            <StyledDataColumn>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.interiorDesign.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.interiorDesign)}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.sanitaryArea.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.sanitaryArea)}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.heatingSystem.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.heatingSystem)}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.pipes.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.pipes)}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.windows.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.windows)}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.thermalInsulation.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.thermalInsulation)}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.roofCoveringAndInsulation.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.roofCoveringAndInsulation)}
                </StyledPropertyValue>
              </StyledDataProperty>
              <StyledDataProperty>
                <StyledPropertyLabel>
                  {t('newAddressModal.modernizationTab.roomLayout.label')}
                </StyledPropertyLabel>
                <StyledPropertyValue>
                  {getModernizationValue(modernizationMatrix?.roomLayout)}
                </StyledPropertyValue>
              </StyledDataProperty>
            </StyledDataColumn>
          </>
        ) : (
          <StyledDataColumn />
        )}
      </StyledDataContainer>
    </StyledSectionContainer>
  )
}

export default ModernizationInfo
